module.exports = __webpack_public_path__ + "img/8th_financial-wellness.aad5d4ae.webp";